import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { Panel } from 'primereact/panel';
import { ProgressSpinner } from 'primereact/progressspinner';
import { Button } from 'primereact/button';
import { InputComponent } from '../../../../components/InputComponent';
import { CatalogoService } from '../../../../service/CatalogoService';
import * as generic from '../../../../components/Generico';
import { CertificacionPn } from '../../../../models/trust/cliente/CertificacionPn';
import { PnService } from '../../../../service/trust/certificacion/PnService';
import { PaisFiscal } from '../../../../components/trust/PaisFiscal';
import { TabPanel, TabView } from 'primereact/tabview';
import { SociedadControl } from '../../../../components/trust/SociedadControl';
import { Dialog } from 'primereact/dialog';
import { AnexosComponent } from "../../../../components/AnexosComponent";
import { useSubmitForm } from '../../../../hooks/useSubmitForm';
import { Message } from 'primereact/message';

export const Certificacion = ({ toast, id, idp, permss, catalogos, handlePrev, soloLectura, tipo, mostrarAnexos, onEstadoCambiado, siCliente }) => {

    const omodel = new CertificacionPn();
    const defaultValues = generic.funDefault(omodel.model, null);
    const { control, formState: { errors }, handleSubmit, reset, setError, getValues, setValue, clearErrors } = useForm({ defaultValues });
    const pnSrv = new PnService();
    const catalogoService = new CatalogoService();
    const [estadoCertificado, setEstadoCertificado] = useState(null);
    const esSoloLectura = soloLectura || estadoCertificado === 'FINALIZADO' || (siCliente && estadoCertificado === 'ENVIADO');
    const { inText, inDrop, inCalendar, inArea } = InputComponent({ omodel, errors, control, permss, id: getValues('id'), soloLectura: esSoloLectura });

    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [ecuador, setEcuador] = useState(false);
    const [ecuadorNacimiento, setEcuadorNacimiento] = useState(false);
    const [ciudades, setCiudades] = useState([]);
    const [ciudadesNacimiento, setCiudadesNacimiento] = useState([]);
    const [esRuc, setEsRuc] = useState(false);
    const [esCedula, setEsCedula] = useState(false);
    const [esEeuu, setEsEeuu] = useState(false);
    const [esExtranjero, setEsExtranjero] = useState(false);
    const [certId, setCertId] = useState(null);
    const botonesInferioresRef = useRef(null);
    const [nombreSujeto, setNombreSujeto] = useState(null);
    const [mostrarNavFlotante, setMostrarNavFlotante] = useState(false);
    const [loadReport, setLoadReport] = useState(false);
    const [activeIndex, setActiveIndex] = useState(0);

    const urlsCert = {
        urlListado: 'ficha/trust/certificacion-pn',
        urlUpload: 'ficha/trust/certificacion-pn/store',
        udelete: 'ficha/trust/certificacion-pn/eliminar-anexo',
        urlDownload: 'ficha/trust/certificacion-pn/descarga',
        uaprobar: 'ficha/trust/certificacion-pn/aprobar',
    };

    const { enviarFormulario, dialogAnexo, setDialogAnexo, anexoPendientes } = useSubmitForm({ toast, setError, onSuccess: (res) => { reiniciar(res.data?.estado); } });

    const subirReporte = () => {
        setDialogAnexo(true);
    };

    const reiniciar = (nuevoEstado) => { // Modifica el estado actual y del padre en caso de ser llamado desde certificacionPj
        handlePrev(); // Función definida para el cierre del modal que contiene el certificado
        if (!nuevoEstado) return;
        setEstadoCertificado(nuevoEstado); // Actualizamos el estado local
        if (onEstadoCambiado) { // Actualizamos el estado en el certificadoPj
            onEstadoCambiado(nuevoEstado);
        }
    }

    useEffect(() => {
        if (id || idp) editFicha();
        // eslint-disable-next-line
    }, [id, idp]);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => { if (!isLoading) setMostrarNavFlotante(!entry.isIntersecting); },
            { threshold: 0 }
        );
        const currentRef = botonesInferioresRef.current;
        if (currentRef) observer.observe(currentRef);
        return () => { if (currentRef) observer.unobserve(currentRef); };
    }, [isLoading, activeIndex]);

    const editFicha = () => {
        setIsLoading(true);
        // Definimos qué ID enviar. Si tenemos el hijo (id), buscamos por hijo. Si no, buscamos por padre (idp)
        const idConsulta = id || idp;
        pnSrv.consultar(idConsulta, { tipo }).then(res => {
            const _data = res.data.certificacion;
            if (!_data || !_data?.apellidos || !_data?.nombres) { reset(defaultValues); return; }
            setNombreSujeto(_data.apellidos + ' ' + _data.nombres);
            setEstadoCertificado(_data.nemonico);

            const isEc = _data.pais?.cat_id === catalogos?.ecuador?.cat_id;
            const isEcNacimiento = tipo !== 'natural' && _data.pais_nacimiento?.cat_id === catalogos?.ecuador?.cat_id;

            setEcuador(isEc);
            setEcuadorNacimiento(isEcNacimiento);

            if (isEc && res.data.ciudades) setCiudades(res.data.ciudades);
            if (isEcNacimiento && res.data.ciudadesNacimiento) setCiudadesNacimiento(res.data.ciudadesNacimiento);

            _data.fecha_nacimiento = generic.stringToDate(_data.fecha_nacimiento);
            _data.fecha = generic.stringToDate(_data.fecha);

            setEsRuc(_data.tipo_identificacion?.cat_id === catalogos?.ruc?.cat_id);
            setEsCedula(_data.tipo_identificacion?.cat_id === catalogos?.cedula?.cat_id);
            setEsEeuu(_data.eeuu_fin_fiscal?.cat_id === true);
            setEsExtranjero(_data.extranjero_fin_fiscal?.cat_id === true);
            // Aquí el formulario descubre cuál es su propio ID hijo si venía null y lo resolvió por el tipo
            setCertId(_data.id ?? null);

            reset(generic.renewValues(_data, omodel.model));
        }).finally(() => setIsLoading(false));
    };

    const onSubmit = (data) => {
        setIsSaving(true);
        data.idp = idp;
        data.fecha_nacimiento = generic.dateToString(data.fecha_nacimiento);
        data.fecha = generic.dateToString(data.fecha);
        data.ec = catalogos?.ecuador;
        data.tipo = tipo;

        const request = getValues('id') == null ? pnSrv.nuevo(data) : pnSrv.editar(data);
        request.then(res => {
            if (res.data?.codigo) {
                setCertId(res.data.codigo);
                // Actualizamos el estado en el formulario para que no falle la condición del request
                setValue('id', res.data.codigo);
            }
            if (res.data?.estado) { // Capturamos el estado en la primera creación para poder subir anexos
                setEstadoCertificado(res.data.estado);
            }
            if (onEstadoCambiado && res.data?.estado) onEstadoCambiado(res.data?.estado);
            generic.funcSuccess(res, toast);
            setActiveIndex(1);
        }).catch(error => {
            generic.funcError(error, toast, setError);
        }).finally(() => setIsSaving(false));
    };

    const onError = () => {
        toast.current.show({ severity: 'error', summary: 'Error', detail: 'Se detectaron errores, por favor revise el formulario para corregir.', life: 3000 });
    };

    const handleNextSeccion = () => setActiveIndex(1);
    const handlePrevSeccion = () => setActiveIndex(0);

    const onChangeTipoIdentificacion = (e) => {
        setEsRuc(JSON.stringify(e.value) === JSON.stringify(catalogos?.ruc));
        setEsCedula(JSON.stringify(e.value) === JSON.stringify(catalogos?.cedula));
        clearErrors('identificacion');
    };

    const tipoDoc = esRuc ? 'IDEN_RUC' : esCedula ? 'IDEN_CEDULA' : null;

    const reglaValidacion = (val) => {
        if (!tipoDoc) return true;
        return generic.validarIdentificacionEcuador(val, tipoDoc) || `${esRuc ? 'RUC' : 'Cédula'} incorrecto`;
    };

    const onChangePais = (e, soloPais) => {
        const esEcuador = e.value?.cat_id === catalogos?.ecuador?.cat_id;
        if (soloPais === true) {
            setEcuador(esEcuador);
            setValue('provincia', null);
            setValue('ciudad', null);
            setValue('canton', '');
            setCiudades([]);
        } else {
            setEcuadorNacimiento(esEcuador);
            setValue('provincia_nacimiento', null);
            setValue('ciudad_nacimiento', null);
            setValue('canton_nacimiento', '');
            setCiudadesNacimiento([]);
        }
    };

    const onChangeProvincia = (e, soloProvincia) => {
        if (soloProvincia === true) {
            setValue('ciudad', null);
            if (!e?.value) { setCiudades([]); return; }
            catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudades(res.data));
        } else {
            setValue('ciudad_nacimiento', null);
            if (!e?.value) { setCiudadesNacimiento([]); return; }
            catalogoService.getCatalogosId(e.value.cat_id).then(res => setCiudadesNacimiento(res.data));
        }
    };

    const onChangeEeuu = (e) => setEsEeuu(e.value?.cat_id === true);
    const onChangeExtranjero = (e) => setEsExtranjero(e.value?.cat_id === true);

    if (isLoading) {
        return (
            <div className="flex flex-column align-items-center justify-content-center p-5">
                <ProgressSpinner style={{ width: '50px', height: '50px' }} strokeWidth="4" animationDuration=".5s" />
                <span className="mt-3 text-color-secondary font-medium text-lg">Consultando información...</span>
            </div>
        );
    }

    const generarReporte = () => {
        setLoadReport(true);
        pnSrv.descargar(certId, { tipo }).then(res => {
            generic.downloadPdf(res, 'Autocertificacion.pdf');
        }).catch(error => {
            generic.funcMessageBlobError('Complete la información antes de generar.', error, toast);
        }).finally(() => setLoadReport(false));
    }

    const enviar = () => {
        enviarFormulario(certId, 'ficha/trust/certificacion-pn/enviar', 'certificacionPn');
    };

    const mostrarIdentificacion = ['inversion', 'deposito', 'pasiva', 'natural', 'control'].includes(tipo);

    return (
        <>
            {(esSoloLectura && siCliente) && (
                <div className="mb-4">
                    <Message severity="warn" text="Esta Auto-certificación ya ha sido enviada y se encuentra en modo de Solo Lectura." className="w-full justify-content-start shadow-1 border-round-md" />
                </div>
            )}
            {tipo !== 'natural' ? (
                <h5 className="text-900 font-bold mb-3">{omodel.tituloControl}</h5>
            ) : (
                <h5 className="text-900 font-bold mb-3">{omodel.tituloNormal}</h5>
            )}
            <form id="form-certificacion" onSubmit={(e) => { e.stopPropagation(); handleSubmit(onSubmit, onError)(e); }}>
                <TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)} className="form-tabview">
                    <TabPanel header="Sección 1" leftIcon="pi pi-id-card mr-2">

                        <Panel header={generic.renderPanelHeader('', 'INICIO', 'pi pi-info-circle')} className="panel-ficha shadow-1 mb-4">
                            <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                                {omodel.strAuto}
                                {tipo === 'control' ? omodel.strControl : omodel.strNormal}
                            </div>
                        </Panel>

                        <Panel header={generic.renderPanelHeader('A', (tipo !== 'natural' ? "Identificación de la persona que ejerce el control" :
                            'Identificación del cuentahabiente'), 'pi pi-user')} className="panel-ficha shadow-1 mb-4">
                            <div className="formgrid grid p-2 p-fluid">
                                {inCalendar('fecha', {}, mostrarIdentificacion ? 4 : 3)}
                                {mostrarIdentificacion && (
                                    <>
                                        {inDrop('tipo_identificacion', catalogos?.tipo_identificacion, { lab: 'nombre', chn: onChangeTipoIdentificacion }, 4)}
                                        {inText('identificacion', { validate: reglaValidacion, icon: 'pi pi-id-card' }, 4)}
                                    </>
                                )}
                                {inText('apellidos', { icon: 'pi pi-user' }, mostrarIdentificacion ? 4 : 3)}
                                {inText('nombres', { icon: 'pi pi-user' }, mostrarIdentificacion ? 4 : 3)}
                                {inCalendar('fecha_nacimiento', {}, mostrarIdentificacion ? 4 : 3)}
                                {tipo !== 'natural' && (
                                    <>
                                        {inDrop('pais_nacimiento', catalogos?.pais, { lab: 'nombre', chn: (e) => onChangePais(e, false), val: false }, 4)}
                                        {ecuadorNacimiento ? (
                                            <>
                                                {inDrop('provincia_nacimiento', catalogos?.provincias, { lab: 'nombre', chn: (e) => onChangeProvincia(e, false), val: false }, 4)}
                                                {inDrop('ciudad_nacimiento', ciudadesNacimiento, { lab: 'nombre', val: false }, 4)}
                                            </>
                                        ) : (
                                            inText('canton_nacimiento', { icon: 'pi pi-map-marker' }, 8)
                                        )}
                                    </>
                                )}
                                {inArea('direccion_residencia', 3, 500, 12)}
                                {inDrop('pais', catalogos?.pais, { lab: 'nombre', chn: onChangePais, val: true }, ecuador ? 3 : 4)}
                                {ecuador ? (
                                    <>
                                        {inDrop('provincia', catalogos?.provincias, { lab: 'nombre', chn: onChangeProvincia, val: true }, 3)}
                                        {inDrop('ciudad', ciudades, { lab: 'nombre' }, 3)}
                                        {inText('codigo_postal', { icon: 'pi pi-hashtag' }, 3)}
                                    </>
                                ) : (
                                    <>
                                        {inText('canton', { icon: 'pi pi-map-marker' }, 4)}
                                        {inText('codigo_postal', { icon: 'pi pi-hashtag' }, 4)}
                                    </>
                                )}
                            </div>
                        </Panel>

                        <Panel header={generic.renderPanelHeader('B', 'Residencia fiscal ' + (tipo !== 'natural' ? 'de la persona que ejerce el control' :
                            'del cuentahabiente'), 'pi pi-flag')} className="panel-ficha shadow-1 mb-4">
                            <div className="formgrid grid p-2 p-fluid align-items-end">
                                {inDrop('eeuu_fin_fiscal', generic.estadosSiNo, { lab: 'nombre', chn: onChangeEeuu }, esEeuu ? 4 : 6)}
                                {esEeuu && inText('eeuu_identificacion', { icon: 'pi pi-id-card' }, 4)}
                                {inDrop('extranjero_fin_fiscal', generic.estadosSiNo, { lab: 'nombre', chn: onChangeExtranjero }, esEeuu ? 4 : 6)}
                            </div>
                        </Panel>

                        <div ref={botonesInferioresRef} className="relative flex justify-content-end align-items-center mt-4 mb-4 px-1" style={{ minHeight: '50px' }}>
                            {esSoloLectura ? (
                                <Button label="Siguiente" icon="pi pi-chevron-right" iconPos="right" type="button" onClick={handleNextSeccion} className="p-button-primary px-4" style={{ width: 'auto' }} />
                            ) : (
                                <Button label={isSaving ? 'Guardando...' : 'Siguiente'} icon={isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-chevron-right'} iconPos="right" type="submit" loading={isSaving} className="p-button-primary px-4" style={{ width: 'auto' }} />
                            )}
                        </div>

                    </TabPanel>

                    <TabPanel header="Sección 2" leftIcon="pi pi-file-check mr-2" disabled={!certId}>
                        {esExtranjero && certId && (
                            <Panel header={generic.renderPanelHeader('B', 'Residencia fiscal ' + (tipo !== 'natural' ? 'de la persona que ejerce el control' :
                                'del cuentahabiente'), 'pi pi-globe')} className="panel-ficha shadow-1 mb-4">
                                <PaisFiscal toast={toast} id={certId} catalogos={catalogos} permss={permss} soloLectura={esSoloLectura} tipo="natural" />
                            </Panel>
                        )}

                        {tipo !== 'natural' && certId && (
                            <Panel header={generic.renderPanelHeader('C', 'Tipo de persona que ejerce el control', 'pi pi-globe')} className="panel-ficha shadow-1 mb-4">
                                <SociedadControl toast={toast} id={certId} catalogos={catalogos} permss={permss} soloLectura={esSoloLectura} />
                            </Panel>
                        )}

                        <Panel header={generic.renderPanelHeader(tipo !== 'natural' ? 'D' : 'C.', 'Certificación y compromiso', 'pi pi-file-check')} className="panel-ficha shadow-1 mb-4">
                            <div className="field col p-3 text-justify line-height-3 text-700 bg-blue-50 border-round border-left-3 border-blue-500">
                                <div className="flex align-items-center gap-2 mb-3">
                                    <i className="pi pi-shield text-blue-600 text-lg"></i>
                                    <span className="font-bold text-blue-900">Declaración</span>
                                </div>
                                {tipo !== 'natural' ? omodel.strCerControl : omodel.strCertificacion(nombreSujeto ?? '')}
                            </div>
                        </Panel>

                        <div ref={botonesInferioresRef} className="flex justify-content-between align-items-center mt-4 mb-4 px-1 w-full" style={{ minHeight: '50px' }}>

                            <div style={{ width: '150px', textAlign: 'left' }}>
                                {activeIndex > 0 && (
                                    <Button label="Anterior" icon="pi pi-chevron-left" type="button" onClick={handlePrevSeccion} className="p-button-outlined p-button-secondary" />
                                )}
                            </div>

                            <div className="flex-grow-1 text-center">
                                {esSoloLectura ? (
                                    <Button label="Anexos" icon="pi pi-copy" title="Ver Anexos" type="button" className="p-button-warning" onClick={subirReporte} />
                                ) : (
                                    generic.buttonsFormsReports(
                                        () => { },
                                        generarReporte,
                                        subirReporte,
                                        enviar,
                                        isSaving || loadReport,
                                        certId != null,
                                        true,
                                        true
                                    )
                                )}
                            </div>
                            <div style={{ width: '150px' }}></div>
                        </div>
                    </TabPanel>
                </TabView>
            </form>

            {mostrarNavFlotante && (
                <div className="flex gap-2 fadein scalein" style={{ position: 'fixed', bottom: '20px', right: '30px', zIndex: 999 }}>

                    {activeIndex > 0 && (
                        <Button icon="pi pi-chevron-left" type="button" onClick={activeIndex === 0 ? handlePrev : handlePrevSeccion} rounded className="p-button-secondary p-button-outlined shadow-4" style={{ width: '45px', height: '45px', backgroundColor: '#fff' }} tooltip="Anterior" tooltipOptions={{ position: 'left' }} />
                    )}

                    {activeIndex === 0 && (
                        esSoloLectura ? (
                            <Button icon="pi pi-chevron-right" type="button" onClick={handleNextSeccion} rounded className="p-button-primary shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Siguiente" tooltipOptions={{ position: 'left' }} />
                        ) : (
                            <Button form="form-certificacion" icon={isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-chevron-right'} type="submit" disabled={isSaving} rounded className="p-button-primary shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Guardar y Siguiente" tooltipOptions={{ position: 'left' }} />
                        )
                    )}
                    {activeIndex === 1 && certId && (
                        <>
                            {!esSoloLectura && (
                                <Button icon={loadReport ? 'pi pi-spin pi-spinner' : 'pi pi-print'} type="button" onClick={generarReporte} disabled={loadReport} rounded className="p-button-warning shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Formulario" tooltipOptions={{ position: 'left' }} />
                            )}
                            <Button icon="pi pi-copy" type="button" onClick={subirReporte} rounded className="p-button-warning shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Anexos" tooltipOptions={{ position: 'left' }} />
                            {!esSoloLectura && (
                                <Button icon="pi pi-send" type="button" onClick={enviar} rounded className="p-button-warning shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Enviar" tooltipOptions={{ position: 'left' }} />
                            )}
                        </>
                    )}
                    {activeIndex === 1 && !esSoloLectura && (
                        <Button form="form-certificacion" icon={isSaving ? 'pi pi-spin pi-spinner' : 'pi pi-save'} type="submit" disabled={isSaving} rounded className="p-button-primary shadow-4" style={{ width: '45px', height: '45px' }} tooltip="Guardar" tooltipOptions={{ position: 'left' }} />
                    )}
                </div>
            )}
            <Dialog visible={dialogAnexo} header="Gestión de Anexos de Certificación" modal className="p-fluid modal-ssize dialog-personalizado" onHide={() => setDialogAnexo(false)} style={{ width: '800px' }}>
                {anexoPendientes && Array.isArray(anexoPendientes) && (
                    <div className="mb-3">
                        <Message severity="warn" text="No se puede enviar el formulario. Faltan los siguientes documentos obligatorios:" className="w-full justify-content-start mb-2" />
                        <ul style={{ color: '#d32f2f', fontWeight: 'bold' }}>
                            {anexoPendientes.map((doc, index) => (
                                <li key={index}>{doc.tipo_adjunto}</li> // Mostramos el nombre del documento que viene del back
                            ))}
                        </ul>
                    </div>
                )}
                <AnexosComponent tipo={tipo} urls={urlsCert} idp={certId} toast={toast} permss={permss} setDialogSubir={setDialogAnexo} soloLectura={esSoloLectura} estado={estadoCertificado} reiniciar={reiniciar} />
            </Dialog>
        </>
    );
};
